import React from "react";
import { Button } from "reactstrap";
import Cross from "../../../../assets/images/verboden/cross.png";
import X from "../../../../assets/images/tot/X.svg";
import Star from "../../../../assets/images/tot/star.svg";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";

const Players = (props) => {
  const { profile_image, display_name, deletePlayer, history, player_id } =
    props;
  const { pathname } = history.location;
  const room_obj = _.get(props, "gameReducer.roomObj");
  const right_words = _.get(room_obj, "game_state.right_words");
  const active_player = _.get(room_obj, "game_state.active_player");
  const player_score = right_words.filter(
    (item) => item.player_id === player_id
  ).length;

  return (
    <div className="tot-player-card">
      <div className="tot-profile-wrap">
        <div className="tot-profile-img-wrap">
          <img
            src={profile_image}
            className="tot-profile-img"
            alt={display_name}
          />
        </div>
        <div className="name-wrap">
          <p className="text name" title={display_name}>
            {display_name}
          </p>
        </div>
      </div>
      <div className="btn-wrap">
        {pathname === "/tot" ? (
          <>
            {player_id === active_player && (
              <Button className="staricon">
                <img src={Star} />
              </Button>
            )}
            {player_score > 0 && (
              <Button className="number">
                <p className="player_score">{player_score}</p>
              </Button>
            )}
            <Button color="themePink" onClick={() => deletePlayer(props)}>
              <img src={X} />
            </Button>
          </>
        ) : (
          <Button color="themePink" onClick={() => deletePlayer(props)}>
            <img src={Cross} />
          </Button>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer
});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Players);
